import { BaseDto } from '@/shared/dtos/base-dto';

export class agrupacion_importacionesDto extends BaseDto {
    public nombre !: string;
 } 
